export default function (props: any) {
    return (
        <svg width="58px" height="59px" viewBox="0 0 58 59" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-931.000000, -8087.000000)">
                    <g transform="translate(931.000000, 8087.741000)">
                        <rect x="0" y="0" width="58" height="58"></rect>
                        <g transform="translate(11.971703, 2.067594)" stroke="#FFFFFF">
                            <path
                                d="M31.1803331,53.8648119 L2.87626067,53.8648119 C2.08547289,53.8648119 1.36947279,53.5460468 0.848411076,53.0286666 C0.324897305,52.5088343 3.35076995e-13,51.7867088 3.35076995e-13,50.9885701 L3.35076995e-13,2.87746786 C3.35076995e-13,2.10507555 0.304054836,1.40256636 0.799369973,0.886412128 C1.32288374,0.340833432 2.05972631,0 2.87626067,0 L31.1803331,0 C32.0483606,0 32.8268881,0.384970136 33.3540799,0.994301848 C33.7917718,1.4994219 34.0565937,2.15656837 34.0565937,2.87746786 L34.0565937,50.9885701 C34.0565937,51.8394276 33.6863334,52.6044638 33.1002922,53.1304262 C32.5902648,53.5865055 31.9184017,53.8648119 31.1803331,53.8648119 Z"
                                strokeWidth="2.04339562"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            ></path>
                            <line
                                x1="6.24370885"
                                y1="9.85648578"
                                x2="6.24370885"
                                y2="13.3673609"
                                strokeWidth="2.04339562"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            ></line>
                            <line
                                x1="6.24370885"
                                y1="26.855167"
                                x2="6.24370885"
                                y2="33.0965015"
                                strokeWidth="2.04339562"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            ></line>
                            <line x1="0" y1="20.3534457" x2="34.0565937" y2="20.3534457" strokeWidth="2.35789474"></line>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
